/**
 * Theme Requirements Aggregation for Sunrise Management
 * 
 * Extends the base preferred theme requirements with Sunrise Management specific
 * component requirements.
 */

import type { ComponentRequirements } from '@vibesites/tokens';
import { componentRequirements as baseRequirements } from '@vibesites/theme-preferred/requirements';

/**
 * Sunrise Management component requirement overrides.
 * Add requirements for any override components here.
 */
const sunrisemanagementOverrides: Record<string, ComponentRequirements> = {
  // Example:
  // Footer: FooterRequirements,
};

/**
 * All component requirements for the Sunrise Management theme.
 * Inherits from preferred theme and overrides with Sunrise Management components.
 */
export const componentRequirements: Record<string, ComponentRequirements> = {
  ...baseRequirements,
  ...sunrisemanagementOverrides,
};

/**
 * Get requirements for a specific component.
 */
export function getComponentRequirements(componentName: string): ComponentRequirements | undefined {
  return componentRequirements[componentName];
}

/**
 * Get all component names that have requirements defined.
 */
export function getRegisteredComponentNames(): string[] {
  return Object.keys(componentRequirements);
}
